export interface SidebarLocalStorageJoyride {
  alreadyShowSidebarJoyride: boolean;
}

export const SIDEBAR_LOCAL_STORAGE_JOYRIDE_KEY = 'sidebarJoyride';
